import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Hint/hint';
import { css } from '@patternfly/react-styles';
export const HintTitle = (_a) => {
    var { children, className } = _a, props = __rest(_a, ["children", "className"]);
    return (React.createElement("div", Object.assign({ className: css(styles.hintTitle, className) }, props), children));
};
HintTitle.displayName = 'HintTitle';
//# sourceMappingURL=HintTitle.js.map